module.exports = __webpack_public_path__ + "static/adam_wajda.3018df0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/adam_wajda.jpg
// module id = 696
// module chunks = 35783957827783